var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef } from 'react';
var FilterPopup = function (_a) {
    var options = _a.options, selectedOptions = _a.selectedOptions, onSelectionChange = _a.onSelectionChange, onClose = _a.onClose;
    var popupRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (popupRef.current &&
                !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
    var isAllSelected = selectedOptions.length === options.length;
    var handleOptionToggle = function (option) {
        if (option === 'All') {
            onSelectionChange(isAllSelected ? [] : __spreadArray([], options, true));
            return;
        }
        var updated;
        if (isAllSelected) {
            updated = [option];
        }
        else if (selectedOptions.includes(option)) {
            updated = selectedOptions.filter(function (item) { return item !== option; });
        }
        else {
            updated = __spreadArray(__spreadArray([], selectedOptions, true), [option], false);
        }
        onSelectionChange(updated);
    };
    return (React.createElement("div", { ref: popupRef, className: "absolute z-20 bg-white rounded-xl shadow-lg pl-4 py-3 w-[218px] mt-2 top-8" },
        React.createElement("div", { className: "max-h-60 overflow-y-auto pr-4 mr-[1px]" }, __spreadArray(['All'], options, true).map(function (option) {
            var isSelected = option === 'All' ? isAllSelected : selectedOptions.includes(option);
            return (React.createElement("div", { key: option, className: "flex items-center justify-between cursor-pointer py-3", onClick: function () { return handleOptionToggle(option); } },
                React.createElement("span", { className: "text-[#252846] font-normal text-base" }, option),
                isSelected && (React.createElement(FontAwesomeIcon, { icon: faCheck, className: "text-[#6768EE]" }))));
        }))));
};
export default FilterPopup;
